import {PANELMANAGER_ACTIVATE_PANEL} from '../../constants';
import {
    StoreState,
    AppDispatch,
    Thunk
} from '~/frontend/src/store';
import {
    panelClasses,
    PanelType,
    PanelClass
} from '~/frontend/src/components/base/page/PageTabPanel/definitions';
import {
    getPanelIndex,
    getPanelKeyByPath
} from '~/frontend/src/components/base/page/PageTabPanel/utilities';
import activatePanel from '~/frontend/src/actions/panelManager/activatePanel';
import openPanel, {
    PanelPropsWithPanelType
} from '~/frontend/src/actions/panelManager/openPanel';

/**
 * @memberOf! Actions
 *
 * @param {string} path
 * @param {string} [panelKey]
 *
 * @return {void}
 */
const activateOrOpenPanelByPath = ( path : string, panelKey? : string ) : Thunk<void> => ( dispatch : AppDispatch, getState : () => StoreState ) : void => {
    path = decodeURI( path );

    const parts  = path.match( /#([^?]*)(\?(.*))?/ ),
          params = parts?.[ 1 ]?.split( '/' );

    if ( !panelKey ) {
        panelKey = getPanelKeyByPath( path, getState().panelManager.openPanels );
    }

    const activate = Boolean( panelKey && getPanelIndex( panelKey, getState().panelManager.openPanels ) !== undefined );

    if ( params?.length ) {
        const panelType           = params[ 0 ] as PanelType,
              PanelComponentClass = panelClasses[ panelType as PanelType ] as unknown as PanelClass;

        if ( PanelComponentClass?.buildPanelPropsFromPath ) {
            const buildFnc = async () => {


                // TODO:
                //  1. error handling not implemented (below)
                //  ISSUES / PROBLEMS:
                //  1. what on panel close? (and close in background)


                try {
                    const panelProps = await PanelComponentClass.buildPanelPropsFromPath!( path, activate ) as PanelProps;

                    // activate open panel
                    if ( activate ) {
                        dispatch(
                            activatePanel(
                                panelKey!,
                                true,
                                panelProps
                            )
                        );
                    }

                    // open new panel
                    else {
                        dispatch(
                            openPanel(
                                {
                                    panelType,
                                    ...panelProps
                                } as PanelPropsWithPanelType,
                                undefined,
                                undefined,
                                undefined,
                                undefined,
                                path
                            )
                        );
                    }
                }
                catch ( e ) {
                    console.error( e );

                    // TODO: error handling -> history.back() ! lastHistoryUrl === BASE_URL

                }
            };

            void buildFnc();
        }
    }
};
export type ActivateOrOpenPanelByPath = typeof activateOrOpenPanelByPath;

export default activateOrOpenPanelByPath;
